import axios from "axios";

import {
  authDeviceWithDomainHeader,
  authWithDomainHeader,
} from "../authServices/auth.header";
import { setExtentions } from "@/helpers/BatchService.js";

const API_URL = process.env.VUE_APP_ROOT_API;
class ExtensionService {
  /***** Extension ******/
  // Get extension list
  async getExtensionList(filter = "") {
    return await axios
      .get(API_URL + `pbx-service/extension` + filter, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get extension list
  async getExtensionListByColurm(filter, domain_uuid = null) {
    return await axios
      .get(API_URL + `pbx-service/extension` + filter, {
        headers: domain_uuid
          ? authWithDomainHeader(domain_uuid)
          : authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get extension
  async getExtension(extension_uuid) {
    return await axios
      .get(API_URL + `pbx-service/extension/${extension_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update extension
  async updateExtension(extension_uuid, data) {
    return await axios
      .put(API_URL + `pbx-service/extension/${extension_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setExtentions();
        return response.data;
      });
  }
  // Update extension status
  async updateStatusExtension(extension_uuid, data) {
    return await axios
      .patch(API_URL + `pbx-service/extension/${extension_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Create extension
  async AddExtension(data) {
    return await axios
      .post(API_URL + `pbx-service/extension`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setExtentions();
        return response.data;
      });
  }
  // Bulk extension create
  async BulkUploadExtension(data) {
    return await axios
      .post(API_URL + `pbx-service/bulk-extension`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setExtentions();
        return response.data;
      });
  }
  // Bulk extension create by excel
  async BulkUploadExtensionByExcel(data) {
    return await axios
      .post(API_URL + `pbx-service/bulk-extension/excl`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setExtentions();
        return response.data;
      });
  }

  // Bulk Update Extension
  async BulkUpdateExtension(data) {
    return await axios
      .patch(API_URL + "pbx-service/bulk-extension", data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setExtentions();
        return response.data;
      });
  }
  // Bulk Update Extension by excel
  async BulkUpdateExtensionByExcel(data) {
    return await axios
      .patch(API_URL + "pbx-service/bulk-extension/excl", data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setExtentions();
        return response.data;
      });
  }

  //delete Extension
  async deleteExtension(extension_uuid) {
    return await axios
      .delete(API_URL + `pbx-service/extension/${extension_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setExtentions();
        return response.data;
      });
  }
  //delete multiple Extension
  async deleteMultiExtension(data) {
    return await axios
      .delete(API_URL + `pbx-service/extension`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setExtentions();
        return response.data;
      });
  }
  // Get extension list by domain id
  async getExtensions(domain_id) {
    return await axios
      .get(API_URL + `pbx-service/extension`, {
        headers: authWithDomainHeader(domain_id),
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new ExtensionService();
